import * as snippet from '@segment/snippet';
import Script from 'next/script';
import { useMemo } from 'react';

const SegmentSnippet = () => {
  const segmentSnippet = useMemo(() => snippet.min({ load: false }), []);

  // eslint-disable-next-line local-rules/require-sanitized-html
  return <Script id="segment-script" dangerouslySetInnerHTML={{ __html: segmentSnippet }} />;
};

export default SegmentSnippet;
